import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mt-2 mb-3" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-9" }
const _hoisted_4 = { class: "input-group" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { value: "" }
const _hoisted_7 = ["label"]
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_10 = { class: "col-3 pe-0 form-height" }
const _hoisted_11 = ["aria-label", "title"]
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-9 form-inline room-dimension" }
const _hoisted_14 = { class: "input-group" }
const _hoisted_15 = ["value", "onInput"]
const _hoisted_16 = ["value", "onInput"]
const _hoisted_17 = ["onInput", "value"]
const _hoisted_18 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_19 = { class: "col-3 form-height ps-3 justify-content-center justify-content-md-start" }
const _hoisted_20 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DoorIcon = _resolveComponent("DoorIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _createElementVNode("span", {
              class: _normalizeClass(["input-group-text input-group-icon my-2", {'is-invalid': _ctx.isRoomNotSelected()}])
            }, [
              _createVNode(_component_DoorIcon, { class: "text-primary" })
            ], 2),
            _createElementVNode("select", {
              class: _normalizeClass(["form-select custom-select my-2", {'is-invalid': _ctx.isRoomNotSelected()}]),
              value: _ctx.state.roomType,
              onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateRoomType($event.target.value)))
            }, [
              _createElementVNode("option", _hoisted_6, _toDisplayString(_ctx.$t('form.floorArea.selectRoomType')), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roomLists, (list, roomGroup) => {
                return (_openBlock(), _createElementBlock("optgroup", {
                  label: _ctx.$t('floorArea.roomGroups.' + roomGroup)
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list, (roomType) => {
                    return (_openBlock(), _createElementBlock("option", { value: roomType }, _toDisplayString(_ctx.$t('floorArea.roomTypes.' + roomType)), 9, _hoisted_8))
                  }), 256))
                ], 8, _hoisted_7))
              }), 256))
            ], 42, _hoisted_5)
          ]),
          (_ctx.isRoomNotSelected())
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('form.errors.roomNotSelected')), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            class: "btn btn-outline-secondary ms-2",
            "aria-label": _ctx.$t('form.floorArea.buttonCloneRoom'),
            title: _ctx.$t('form.floorArea.buttonCloneRoom'),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('clone')))
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("span", { class: "fas fa-clone" }, null, -1)
          ]))], 8, _hoisted_11),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeRoom && _ctx.removeRoom(...args))),
            class: "btn btn-outline-secondary ms-2"
          }, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("span", { class: "fas fa-times" }, null, -1)
          ]))])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.dimensions, (dimensionsEntry, index) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, [
              _createElementVNode("input", {
                value: dimensionsEntry[0],
                placeholder: "X",
                onInput: ($event: any) => (_ctx.updatedDimensions(index, 0, $event.target.value)),
                class: _normalizeClass(["form-control", {'is-invalid': ! _ctx.areValid(index)}])
              }, null, 42, _hoisted_15),
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "input-group-text rounded-end" }, "m", -1)),
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "px-3 py-2" }, "×", -1)),
              _createElementVNode("input", {
                value: dimensionsEntry[1],
                placeholder: "Y",
                onInput: ($event: any) => (_ctx.updatedDimensions(index, 1, $event.target.value)),
                class: _normalizeClass(["form-control rounded-start", {'is-invalid': ! _ctx.areValid(index)}])
              }, null, 42, _hoisted_16),
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "input-group-text rounded-end" }, "m", -1)),
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "px-3 py-2" }, "=", -1)),
              _createElementVNode("input", {
                type: "text",
                onInput: ($event: any) => (_ctx.updatedDimensions(index, 2, $event.target.value)),
                value: dimensionsEntry[2],
                class: _normalizeClass(["form-control rounded-start", {'is-invalid': ! _ctx.areValid(index)}])
              }, null, 42, _hoisted_17),
              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "input-group-text" }, [
                _createTextVNode("m"),
                _createElementVNode("sup", null, "2")
              ], -1))
            ]),
            (! _ctx.areValid(index))
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.$t('form.errors.invalidRoomDimensions')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_19, [
            (index > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: ($event: any) => (_ctx.removeDimensions(index)),
                  class: "btn btn-outline-secondary ms-2"
                }, [...(_cache[11] || (_cache[11] = [
                  _createElementVNode("span", { class: "fas fa-times" }, null, -1)
                ]))], 8, _hoisted_20))
              : _createCommentVNode("", true),
            (index === _ctx.state.dimensions.length - 1)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addDimensions && _ctx.addDimensions(...args))),
                  class: "btn btn-outline-secondary ms-2"
                }, [...(_cache[12] || (_cache[12] = [
                  _createElementVNode("span", { class: "fas fa-plus" }, null, -1)
                ]))]))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 256))
    ])
  ]))
}